// extracted by mini-css-extract-plugin
export var infoItem = "_qf-2";
export var title = "_qf-0";
export var value = "_qf-1";